import { Card } from '@mui/material'
import { FC } from 'react'
import { Image } from './Image'

interface Props {
    href: string
}

const InlineImage: FC<Props> = ({ href }) => {
    return (
        <Card sx={{ p: 1 }}>
            <Image src={href} isDoneLoading isAssistant />
        </Card>
    )
}

export default InlineImage
